import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: 100%;
`;

const Wrapper = styled.div`
  box-sizing: content-box;

  width: 10rem;
  margin: 4rem auto;
  padding: 1rem;
`;

const WrapperBtn = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`;

const SpinnerWrapper = styled.div`
  position: absolute;
  right: 10px;
`;

export { Container, Wrapper, WrapperBtn, SpinnerWrapper };
